import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import clsx from "clsx";
import { useAuth } from "@/contexts/AuthContext";
import AgencyDashboard from "@/components/agency/AgencyDashboard";
import AgencySubaccounts from "@/components/agency/AgencySubaccounts";
import AgencyWhitelabel from "@/components/agency/AgencyWhitelabel";
import { AgencyUsers } from "@/components/agency/AgencyUsers";

type TabId = "dashboard" | "subcontas" | "whitelabel" | "usuarios";

interface Tab {
  id: TabId;
  label: string;
  component: React.ReactNode;
}

const Agency: React.FC = () => {
  const { user, loading } = useAuth();
  const [activeTab, setActiveTab] = useState<TabId>("dashboard");

  // Verificar se o usuário está carregando
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-4 border-neutral-600 border-t-neutral-50 rounded-full animate-spin"></div>
          <p className="text-neutral-50">Carregando...</p>
        </div>
      </div>
    );
  }

  // Verificar se o usuário é agency_user
  if (!user || user.type !== 'agency_user') {
    console.warn('⚠️ [Agency] Acesso negado: usuário não é agency_user');
    return <Navigate to="/" replace />;
  }

  const tabs: Tab[] = [
    {
      id: "dashboard",
      label: "Dashboard",
      component: <AgencyDashboard />,
    },
    {
      id: "subcontas",
      label: "Subcontas",
      component: <AgencySubaccounts />,
    },
    {
      id: "usuarios",
      label: "Usuários Agência",
      component: <AgencyUsers />,
    },
    {
      id: "whitelabel",
      label: "Whitelabel",
      component: <AgencyWhitelabel />,
    },
  ];

  return (
    <div className="w-full flex h-[calc(100dvh-110px)] flex-col">
      <h2 className="text-[26px] mb-[10px] sm:text-[30px] font-semibold text-neutral-50">
        Gerenciar Agência
      </h2>

      <div className="flex gap-2 border-b border-[#3F3F464D] mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={clsx(
              "px-6 py-3 text-sm font-medium transition-all relative",
              activeTab === tab.id
                ? "text-red-400 border-b-2 border-red-500"
                : "text-neutral-400 hover:text-neutral-200"
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="flex-1 min-h-0 overflow-auto">
        {tabs.find((tab) => tab.id === activeTab)?.component}
      </div>
    </div>
  );
};

export default Agency;
